import { defineStore, acceptHMRUpdate } from 'pinia'
import { useWorkspaceStore } from '~/stores/workspace'
import { useUserStore } from '~/stores/user'
import { SseMessageType } from '~/types/SseMessage'
import type { SseEventMap } from '~/types/SseMessage'

export const useWorkspaceSseStore = defineStore('workspace-sse', () => {
  // OTHER STORES ========================================================================
  const workspaceStore = useWorkspaceStore()
  const userStore = useUserStore()

  // SSE STATE ========================================================================
  const config = useRuntimeConfig()
  const serverUrl = config.public.serverUrl

  const sseUrl = computed(() => {
    if (!workspaceStore.currentWorkspace?.id) return undefined
    if (!userStore.user?.id) return undefined
    if (!serverUrl) return undefined
    return `${serverUrl}/workspaces-sse/${workspaceStore.currentWorkspace.id}/users/${userStore.user.id}`
  })

  // HANDLERS ==========================================================================

  function isKnownEventType(value: string): value is keyof SseEventMap {
    return Object.values(SseMessageType).includes(value as SseMessageType)
  }

  function handleData(data: string | null) {
    if (!data) return

    let parsedData: any

    try {
      parsedData = JSON.parse(data)
    } catch (e) {
      console.error('Error parsing data:', e)
      return
    }

    if (!parsedData.eventType) {
      console.warn('Tried to publish data, but no topic (type) was provided')
      return
    }

    if (!isKnownEventType(parsedData.eventType)) {
      console.warn(
        `[WorkspaceSse] Received unknown SSE event type: ${parsedData.eventType}`,
      )
      return
    }

    emitEvent(parsedData.eventType, parsedData)
  }

  // EVENT SOURCE & WATCHER ============================================================

  const { status, error } = useSse(sseUrl, handleData)

  return { status, error }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useWorkspaceSseStore, import.meta.hot))
}
